import React, { useEffect } from 'react';

import { Alert, Stack } from '@gogame/components';
import { AmountFormatter } from '@gogame/intl-ts';
import { useMountedState } from '@gogame/hooks-ts';
import { useAccessToken } from 'Auth';

import Invoice from './Invoice';

const Invoices = ({ invoices = [], totalAmount }) => {
  const [accessToken, setAccessToken] = useMountedState();
  const getAccessToken = useAccessToken();

  useEffect(() => {
    getAccessToken().then(setAccessToken);
  }, []);

  return (
    <Stack spacing={2}>
      <Alert severity={'info'}>
        Total invoices amount &nbsp;
        <AmountFormatter {...totalAmount} />
      </Alert>
      {invoices.map((invoice) => (
        <Invoice
          data={invoice}
          initialOpen={invoices.length === 1}
          accessToken={accessToken}
          key={invoice.id + '_' + invoice.attachment.id}
        />
      ))}
    </Stack>
  );
};

export default Invoices;
